import React from 'react';
import { A4 } from './pdfEngine';
import { PDF_HEADER_IMG, PDF_FOOTER_RESERVE_PX } from './PdfA4Page';
import { pdfCellValue } from './PdfTable';

/**
 * Hidden off-screen template used by `calculatePdfPagination` to measure the
 * real rendered heights of the header, table header, rows and footer.
 * Ids follow the `${idPrefix}-pdf-measure-*` convention consumed by
 * usePdfExport. Table layout/widths MUST mirror PdfTable exactly so measured
 * row heights match the printed output.
 */
const cell = {
  border: '1px solid #000',
  padding: '6px',
  textAlign: 'center',
  wordBreak: 'break-word',
};

const PdfMeasureTemplate = ({
  idPrefix,
  title,
  columns,
  rows,
  sampleSize = 30,
  renderRow,
}) => {
  const sample = (rows || []).slice(0, sampleSize);
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '-9999px',
        top: 0,
        width: `${A4.WIDTH_PX}px`,
        pointerEvents: 'none',
        visibility: 'hidden',
      }}
    >
      <div id={`${idPrefix}-pdf-measure-top-header`} style={{ width: '100%' }}>
        <img
          src={PDF_HEADER_IMG}
          alt=""
          style={{
            width: '95%',
            height: 'auto',
            objectFit: 'contain',
            marginBottom: '8px',
            borderBottom: '4px double #000',
            paddingBottom: '8px',
          }}
        />
        <h2 style={{ textAlign: 'center', fontSize: '18px', margin: '8px 0' }}>
          {title}
        </h2>
      </div>
      <table
        style={{
          width: '100%',
          // Must mirror PdfTable exactly so measured row heights match print.
          tableLayout: 'fixed',
          borderCollapse: 'collapse',
          fontSize: '11px',
          border: '1px solid #000',
        }}
      >
        <thead id={`${idPrefix}-pdf-measure-thead`}>
          <tr>
            <th style={{ ...cell, width: '5%' }}>#</th>
            {columns.map(col => (
              <th
                key={col.key || col.label}
                style={{ ...cell, width: col.width }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody id={`${idPrefix}-pdf-measure-tbody`}>
          {sample.map((row, idx) => {
            if (renderRow) return renderRow(row, idx, idx);
            return (
              <tr key={idx}>
                <td style={cell}>{idx + 1}</td>
                {columns.map(col => (
                  <td key={col.key || col.label} style={cell}>
                    {pdfCellValue(row, col, idx)}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div
        id={`${idPrefix}-pdf-measure-footer`}
        style={{ height: `${PDF_FOOTER_RESERVE_PX}px` }}
      />
    </div>
  );
};

export default PdfMeasureTemplate;
